<template>
  <div class="podium-step">
    <div class="position">{{ position }}</div>
    <div class="informations">
      <div>
        <h4>{{ user.name }}</h4>
        <i>{{ user.email }} | {{ user.phone }}</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'podium-step',
  props: {
    color: String,
    position: Number,
    user: Object
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.podium-step {
  display: flex;
  flex-direction: row;
  color: white;
  width: 100%;
  background-color: #b10030;
  height: auto;
  border-radius: 10px;
  padding: 5px;

  .position {
    font-size: 30px;
    display: flex;
    align-items: center;
    margin: 3px 10px 3px 10px;
  }

  .informations {
    width: 100%;
    display: flex;
    align-items: center;
  }
}
</style>